export const switchContractAgreement = (contractTerm) => ({
    type: 'SWITCH_CONTRACT_AGREEMENT',
    contractTerm
});
export  const triggerFTRMatrix = (data) => ({
    type: "SAVE_FTR_MATRIX",
    data
});